// Copyright (C) 2017-2023 Smart code 203358507

const TooltipProvider = require('./TooltipProvider');
const Tooltip = require('./Tooltip');

module.exports = {
    TooltipProvider,
    Tooltip,
};
